var $container = $('#simulator');

//create autocomplete for Mediapost
function autocompleteMediapost(address) {
  console.log(address);
  $(address.zipCode).autocomplete({
      minLength: 3,
      maxLength: 5,
      source: function(request, response) {
        //Pas d'automcompletion pour une adresse hors de France
        $.ajax({
          type: "GET",
          url: api.url + '/api/Mediapost/GetZipInfoByZipcode',
          data: {zipCode: request.term},
          success: function(data) {
            // do stuff with json (in this case an array)
            if (data.length === 1) {
              $(this).css('background-color', '#ffffff');
              address.city.val(data[0].city);
              address.refMediapostVille.val(data[0].value);
              return response(null);
            }
            else {
              address.city.val('');
              $(this).css('background-color', '#f6f5f3');
              return response(data);
            }
          },

          error: function(jqXHR, textStatus, errorThrown) {
            // console.log(jqXHR);
            // console.log(textStatus);
            // console.log(errorThrown);
          }
        });
      },
      focus: function(e, ui) {
        return false;
      },
      select: function(e, ui) {
        e.preventDefault();
        $(address.zipCode).val(ui.item.label);
        $(address.city).val(ui.item.city);
        $(address.refMediapostVille).val(ui.item.value);
      }
    })
    .autocomplete("instance")._renderItem = function(ul, item) {

    return $("<li>")
      .append(item.label + " (" + item.city + ")")
      .appendTo(ul);
  };

}


//Get the address components
function getAddressEls(ctn) {
  if (ctn != null) {
    var addressEls = {
      container: ctn,
      country: $(ctn).find('[name=Country]'),
      zipCode: $(ctn).find('[name=ZipCode]'),
      city: $(ctn).find('[name=City]'),
      refMediapostVille: $(ctn).find('[name=RefMediapostVille]'),
      streetNumber: $(ctn).find('[name=StreetNumber]'),
      street: $(ctn).find('[name=Street]'),
      refMediapostVoie: $(ctn).find('[name=RefMediapostVoie]'),
      postalBox: $(ctn).find('[name=PostalBox]'),

      waiter: $(ctn).find('[name=AddressWait]'),
      labels: $(ctn).find('[name=lbl-StreetNumber], [name=lbl-Street], [name=lbl-PostalBox]'),
      ticks: $(ctn).find('span[for=StreetNumber], span[for=Street], span[for=PostalBox]'),
      valLabel: $(ctn).find('[data-valmsg-for="StreetNumber"]')
    };

    return addressEls;
  }
  return null;
}

$(document).ready(function() {

  var t = null;

  if($container.html()) {
    autocompleteMediapost(getAddressEls($container));
  }

  $container.find('input[type="text"]').keyup(function() {
    // console.log('keyup');
    var empty = true;
    $('input[type="text"]').each(function() {
      // console.log($(this).attr('name') + ' /// ' + $(this).attr('required') + ' /// ' + $(this).val());

      if ($(this).attr('required') === 'required' && $(this).val() === '') {
        empty = false;
      }
      // console.log($(this).val());
      if ($(this).val() === '') {
        $(this).css('background-color', '#f6f5f3');
      } else {
        $(this).css('background-color', '#ffffff');
      }
    });


    if (empty) {

      if (t !== null) {
        clearTimeout(t);
      }

      t = setTimeout(function() {
        $.get({
            url: api.url+'/api/Simulator/CalculateMel',
            data: {refVille: $('#RefMediapostVille').val(), surface: $('#Surface').val(), loyer: $('#Rent').val()},
          })
          .done(function(data) {
            $('#PrixUnitaire').text(data.PrixUnitaire);
            $('#FraisEntremise').text(data.FraisEntremise);
            $('#FraisGestion').text(data.FraisGestion);
            $('#FraisNonPlafonne').text(data.FraisNonPlafonne);
            $('#FraisEtatDesLieux').text(data.FraisEtatDesLieux);

            // reformat total
            $('#Total').text(data.Total);

          }).fail(function(jqXHR, textStatus) {
          // console.log("Request failed: " + textStatus);
        });
      }, 500);

    }

  });


  $('#resfresh__button').click(function(){
    $container.find('#Surface').trigger('keyup');
  });
});
